import React from 'react';

const SettingsPage: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Settings</h2>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg p-6">
        <p className="text-gray-600">System configuration and preferences</p>
        <p className="text-sm text-gray-500 mt-2">
          Configure API endpoints, WebSocket connections, and application settings
        </p>
      </div>
    </div>
  );
};

export default SettingsPage;
